// Centralized API routes for the frontend
export const API_ROUTES = {
  ABOUT: {
    GET: '/api/about/get-about',
    ADD: '/api/about/add-about',
    UPDATE: '/api/about/update-about',
    DELETE: '/api/about/delete-about'
  },
  CAREERS: {
    ADD: '/api/add-careers'
  },
  CAREERS_PAGE: {
    GET: '/api/careers-page'
  },
  JOBS: {
    GET: '/api/jobs'
  },
  ERP_JOBS: {
    GET: '/api/erp-jobs' // live published openings from the NCET ERP (local fallback)
  },
  CONTACT_PAGE: {
    GET: '/api/contact-page'
  },
  ADMISSION_PAGE: {
    GET: '/api/admission-page'
  },
  SITE_SETTINGS: {
    GET: '/api/site-settings'
  },
  APPROVALS: {
    GET: '/api/approvals'
  },
  GALLERY: {
    GET: '/api/gallery'
  },
  NCC: {
    GET: '/api/ncc'
  },
  IIC: {
    GET: '/api/iic'
  },
  PRIVACY: {
    GET: '/api/privacy/getPrivacy'
  },
  TERMS: {
    GET: '/api/terms/getTerms'
  },
  GLOBAL_DEPARTMENTS: {
    GET: '/api/global-departments'
  },
  DEPARTMENTS: {
    BASE: '/api/departments' // append /:id
  },
  DEPARTMENT_DETAILS: {
    BASE: '/api/department-details' // append /:id
  },
  BLOGS: {
    BASE: '/api/blogs' // append /:id
  },
  AUDIT_REPORTS: {
    GET: '/api/audit-reports'
  },
  MONTHLY_REPORTS: {
    GET: '/api/monthly-reports'
  },
  EXAMINATION: {
    GET: '/api/examination'
  },
  IQAC: {
    GET: '/api/iqac'
  },
  NISP_POLICY: {
    GET: '/api/nisp-policy'
  },
  RESEARCH: {
    GET: '/api/research'
  },
  SAMASHTI: {
    GET: '/api/samashti'
  },
  PLACEMENTS: {
    GET: '/api/placements'
  },
  HOME: {
    GET: '/api/home'
  },
  AUTONOMOUS_REGULATIONS: {
    GET: '/api/autonomous-regulations'
  },
  ALUMNI_COMMITTEE: {
    GET: '/api/alumni-committee'
  },
  IDEA_LAB: {
    GET: '/api/idealab'
  },
  NIRF: {
    GET: '/api/nirf'
  },
  NBA_VISIT_DATA: {
    GET: '/api/nba-visit-data'
  },
  HOSTEL: {
    GET: '/api/hostel'
  },
  PAGE_BANNERS: {
    GET: '/api/page-banners'
  }
};
